import React from 'react';
import '../App.css';
import { Button } from './Button';
import './HeroSection.css';

function HeroSection() {
  const handleButtonClick = () => {
    window.open('https://youtu.be/XIoyztV2nsc?si=bwl_WwoVA0ngMJon', '_blank');
  };

  return (
    <div className='hero-container'>
      <video src='/videos/video-1.mp4' autoPlay loop muted />
      <h1>BCCY CÓRDOBA</h1>
      <p>Abogar por una economía baja en carbono y contribuir con energía limpia</p>
      <div className='hero-btns'>
        <Button
          className='btns'
          buttonStyle='btn--primary'
          buttonSize='btn--large'
          onClick={handleButtonClick}
        >
          MIRAR VIDEO <i className='far fa-play-circle' />
        </Button>
      </div>
    </div>
  );
}

export default HeroSection;
